module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modalcon"
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "closebtn",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mbox"
  }, [_c('div', {
    staticClass: "modal-header prelative"
  }, [_c('img', {
    staticClass: "notify-logo",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/exclusive/NotifyLogo.png",
      "alt": "TSS Exclusive Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mb0"
  }, [_c('div', {
    staticClass: "congratulations text-center fbold"
  }, [_vm._v("Congratulations!")]), _vm._v(" "), _c('div', {
    staticClass: "notify-title"
  }, [_vm._v("The Exclusive membership has been added to your cart at an introductory price of "), _c('span', {
    staticClass: "fbold"
  }, [_vm._v("₹ 199 ")]), _vm._v(" / year")]), _vm._v(" "), _c('div', {
    staticClass: "fbold text-center benefits"
  }, [_vm._v("BENEFITS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("BIG discounts on all products")]), _vm._v(" "), _c('li', [_vm._v("Prioritised order processing")]), _vm._v(" "), _c('li', [_vm._v("Free shipping on all orders")]), _vm._v(" "), _c('li', [_vm._v("Early access to some of our latest products")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block text-uppercase btn-notify pointer",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Continue Shopping")]), _vm._v(" "), _c('div', {
    staticClass: "info text-center",
    staticStyle: {
      "margin": "0",
      "margin-bottom": "20px"
    }
  }, [_vm._v("If you reeaaallly want to know more, "), _c('router-link', {
    attrs: {
      "to": "/exclusive",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Click Here")])], 1)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cb2face"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NotifyModal.vue
// module id = 1501
// module chunks = 24 115